<template>
  <h1>In Progress</h1>
</template>

<script>
export default {
  name: 'Totalizers',
  async created () {
  },
}
</script>

<style>

</style>
